'use strict';

var _commonjsHelpers = require('../../../../_virtual/_commonjsHelpers.js');
var reactIs_production_min = require('./cjs/react-is.production.min.js');
var reactIs_development = require('./cjs/react-is.development.js');

var reactIs = _commonjsHelpers.createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min['default'];
} else {
  module.exports = reactIs_development;
}
});

module.exports = reactIs;
